import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { CheckCircle2, ExternalLink } from 'lucide-react';

interface ShareSuccessCardProps {
  videoTitle: string;
  onGoToVideos: () => void;
  onClose: () => void;
}

export function ShareSuccessCard({
  videoTitle,
  onGoToVideos,
  onClose,
}: ShareSuccessCardProps) {
  useLanguage();
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="w-full bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] overflow-hidden"
    >
      <div className="p-8 sm:p-10 text-center">
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6"
        >
          <CheckCircle2 className="w-10 h-10 text-emerald-600" />
        </motion.div>

        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
          {translateInterfaceText("Vídeo adicionado com sucesso")}</h1>
        <p className="text-sm text-muted-foreground max-w-sm mx-auto mb-2">
          <span className="font-medium text-foreground">{videoTitle}</span> {" "}{translateInterfaceText("foi copiado para sua conta.")}</p>
        <p className="text-sm text-muted-foreground">
          {translateInterfaceText("Você já pode acessá-lo em")}{" "}<span className="font-medium text-foreground">{translateInterfaceText("Meus Vídeos")}</span>.
        </p>
      </div>

      {/* CTAs */}
      <div className="px-8 sm:px-10 pb-8 sm:pb-10 space-y-3">
        <Button
          onClick={onGoToVideos}
          className="w-full h-12 bg-[#4B7BFF] hover:bg-[#3B6BEF] text-white font-medium"
        >
          <ExternalLink className="w-4 h-4 mr-2" />
          {translateInterfaceText("Ir para Meus Vídeos")}</Button>
        <Button
          variant="ghost"
          onClick={onClose}
          className="w-full hover:bg-muted hover:text-[#020817]"
        >
          {translateInterfaceText("Fechar")}</Button>
      </div>
    </motion.div>
  );
}
